/**
 * Resources owned by the currently rendered page (observers, timers). Released before the next render,
 * so nothing from a previous page keeps running.
 */
type Cleanup = () => void;

let cleanups: Cleanup[] = [];

export function onPageCleanup(cleanup: Cleanup): void {
  cleanups.push(cleanup);
}

/** Registers an observer so it is disconnected when the page changes. Returns the observer. */
export function trackObserver<O extends { disconnect(): void }>(observer: O): O {
  onPageCleanup(() => {
    observer.disconnect();
  });
  return observer;
}

export function cleanupPage(): void {
  const pending = cleanups;
  cleanups = [];
  pending.forEach((cleanup) => {
    cleanup();
  });
}
